module.exports = __webpack_public_path__ + "img/1f9e9.3206d93.svg";